var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThemessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(-120 -460)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "bg",
    cx: 52,
    cy: 52,
    r: 52,
    transform: "translate(120 460)",
    fill: "#263a4b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(146.025 486.022)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "message-circle",
    transform: "translate(1.975 1.978)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 2.392,
    cy: 2.392,
    r: 2.392,
    transform: "translate(21.588 21.581)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 2.392,
    cy: 2.392,
    r: 2.392,
    transform: "translate(31.155 21.581)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    cx: 2.392,
    cy: 2.392,
    r: 2.392,
    transform: "translate(12.02 21.581)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1906",
    "data-name": "Path 1906",
    d: "M42.866,9.039A23.92,23.92,0,0,0,3.925,35.351a2.536,2.536,0,0,1,.215,1.531L2.035,47a2.377,2.377,0,0,0,2.392,2.87h.478l10.238-2.057a3.014,3.014,0,0,1,1.531.215A23.92,23.92,0,0,0,42.985,9.087Zm1.985,20A19.136,19.136,0,0,1,18.539,43.579a7.8,7.8,0,0,0-2.99-.622,8.2,8.2,0,0,0-1.34.12L7.465,44.44l1.363-6.745a7.391,7.391,0,0,0-.5-4.329,19.139,19.139,0,1,1,36.525-4.329Z",
    transform: "translate(-1.975 -1.978)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThemessage);
export default __webpack_public_path__ + "static/media/themessage.9ae90422f3f489a579f2f3e0302b234e.svg";
export { ForwardRef as ReactComponent };